import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback } from 'reactstrap';
import { validationInputProps } from "../../../utils/inputValidation";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../../clientes/Empresas/Create.js"

import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaContacto: new Date(),
            empresa_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa_id: data.empresa_id
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.contactos.edit}
                postUrl={api.proyectos.contactos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Contacto ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Contacto"}
                buttonTitle={"Editar Contacto"}
                buttonIcon={"fa fa-pencil fa-lg"}
                className={"ui-modal-dialog"}

                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>
                <div className="ui-form">
                    <p className="ui-section-label">Datos del contacto</p>
                    <div className="ui-row-2">
                        <div className="ui-field">
                        <Label>Fecha de Contacto</Label>
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'fechaContacto', className: 'form-control' }}
                            value={this.state.fechaContacto}
                            onChange={(e) => this.setState({ fechaContacto: e._d })}
                        />
                        </div>
                        <div className="ui-field">
                        <Label>Empresa/Organización</Label>
                        <ParadigmaAsyncSeeker Create={CreateEmpresas} fieldName={"empresa_id"}
                            url={api.clientes.empresas.select} value={this.state.empresa_id}
                            onChange={(value) => this.setState({ empresa_id: value.pk })}
                        />
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                    <div className="ui-row-2">
                        <div className="ui-field">
                        <Label>Email</Label>
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                        <div className="ui-field">
                        <Label>Teléfono</Label>
                        <Input type="text" name="telefono" ></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                        <Label>Observaciones</Label>
                        <Input rows={10} type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>

                    <div className="ui-divider"></div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                        <Label>Creado por</Label>
                        <Input disabled={true} type="text" name="user" />
                        </div>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Edit.js